import Lights from 'shared/components/lights';

const requireLoginModal = require('templates/modals/require_login_modal.jst.jade')

export default class RequireLoginModal {

  constructor({ element: element }) {
    this.element = element;
    this.html = null;
    this.body = $('body');
    this.lights = Lights;
    this.ui = {
      root: '.popup',
      icon: '.popup__icon',
      close: '.popup__close',
      content: '.popup__content'
    };
  }

  init() {
    $(this.element).click(this.onClick.bind(this));
  }

  onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.lights.off.bind(this)();
    this.render();
    this.body.append(this.html);
    this.onClose();
    document.getElementsByTagName("body")[0].style.overflow = 'hidden';
    window.scrollTo(0,0);
  }

  onClose() {
    this.html.find(this.ui.close).on('click', function() {
      this.close();
    }.bind(this));
  }

  render() {
    var content = $(requireLoginModal($(this.element).data()));
    this.html = content;
  }

  close() {
    $(this.ui.root).remove();
    this.lights.on();
  }
}
